// Cycles through child [data-slide] items with a soft crossfade; pauses on hover/focus.
class SRotator extends HTMLElement {
  #ac;
  #timer;
  #index = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const slides = this.#slides();
    if (slides.length < 2) return;
    slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === 0));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.addEventListener('pointerenter', () => this.#stop(), opts);
    this.addEventListener('pointerleave', () => this.#start(), opts);
    this.addEventListener('focusin', () => this.#stop(), opts);
    this.addEventListener('focusout', () => this.#start(), opts);
    this.#start();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#stop();
  }

  #slides() {
    return [...this.querySelectorAll('[data-slide]')];
  }

  #start() {
    this.#stop();
    const interval = Number(this.dataset.interval) || 4500;
    this.#timer = setInterval(() => this.#next(), interval);
  }

  #stop() {
    clearInterval(this.#timer);
  }

  #next() {
    const slides = this.#slides();
    slides[this.#index].removeAttribute('data-active');
    this.#index = (this.#index + 1) % slides.length;
    slides[this.#index].setAttribute('data-active', '');
  }
}

customElements.define('s-rotator', SRotator);
